module.exports = __webpack_public_path__ + "static/media/V6.db725a2b.png";